import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify, {
  theme: {
    dark: true
  }
});

export default new Vuetify({
  icons: {
    iconfont: "mdi",
    values: {
      square: "mdi-square",
      triangle: "mdi-triangle",
      power: "mdi-power-cycle"
    }
  },
  theme: {
    themes: {
      dark: {
        primary: "#5b665b",
        secondary: "#444f45",
        accent: "#323c32",
        error: "#f44336",
        warning: "#ffeb3b",
        success: "#4caf50"
      }
    }
  }
});